import { cabinetApi as api } from "../api";
export const addTagTypes = ["api", "OrgSharedLeaderGrant"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      appCoreDevicesList: build.query<
        AppCoreDevicesListApiResponse,
        AppCoreDevicesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/devices/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appCoreDevicesCreate: build.mutation<
        AppCoreDevicesCreateApiResponse,
        AppCoreDevicesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/devices/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreDevicesRetrieve: build.query<
        AppCoreDevicesRetrieveApiResponse,
        AppCoreDevicesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/devices/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      appCoreDevicesUpdate: build.mutation<
        AppCoreDevicesUpdateApiResponse,
        AppCoreDevicesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/devices/${queryArg.registrationId}/`,
          method: "PUT",
          body: queryArg.fcmDeviceRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreDevicesPartialUpdate: build.mutation<
        AppCoreDevicesPartialUpdateApiResponse,
        AppCoreDevicesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/devices/${queryArg.registrationId}/`,
          method: "PATCH",
          body: queryArg.patchedFcmDevice,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreDevicesDestroy: build.mutation<
        AppCoreDevicesDestroyApiResponse,
        AppCoreDevicesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/devices/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersList: build.query<
        AppCoreLeadersListApiResponse,
        AppCoreLeadersListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["api"],
      }),
      appCoreLeadersCreate: build.mutation<
        AppCoreLeadersCreateApiResponse,
        AppCoreLeadersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersRetrieve: build.query<
        AppCoreLeadersRetrieveApiResponse,
        AppCoreLeadersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      appCoreLeadersUpdate: build.mutation<
        AppCoreLeadersUpdateApiResponse,
        AppCoreLeadersUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.leaderRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersPartialUpdate: build.mutation<
        AppCoreLeadersPartialUpdateApiResponse,
        AppCoreLeadersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedLeader,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersDestroy: build.mutation<
        AppCoreLeadersDestroyApiResponse,
        AppCoreLeadersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersAdminDeleteDestroy: build.mutation<
        AppCoreLeadersAdminDeleteDestroyApiResponse,
        AppCoreLeadersAdminDeleteDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/${queryArg}/admin-delete/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersAdminPatchPartialUpdate: build.mutation<
        AppCoreLeadersAdminPatchPartialUpdateApiResponse,
        AppCoreLeadersAdminPatchPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/${queryArg.id}/admin-patch/`,
          method: "PATCH",
          body: queryArg.patchedLeader,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersAdminShareLeaderCreate: build.mutation<
        AppCoreLeadersAdminShareLeaderCreateApiResponse,
        AppCoreLeadersAdminShareLeaderCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/${queryArg.id}/admin-share-leader/`,
          method: "POST",
          body: queryArg.mutateSharedLeaderGrantRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersAdminTransferLeaderCreate: build.mutation<
        AppCoreLeadersAdminTransferLeaderCreateApiResponse,
        AppCoreLeadersAdminTransferLeaderCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/${queryArg.id}/admin-transfer-leader/`,
          method: "POST",
          body: queryArg.leaderRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersAdminUploadProfilePicCreate: build.mutation<
        AppCoreLeadersAdminUploadProfilePicCreateApiResponse,
        AppCoreLeadersAdminUploadProfilePicCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/${queryArg.id}/admin_upload_profile_pic/`,
          method: "POST",
          body: queryArg.leaderRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersShareCreate: build.mutation<
        AppCoreLeadersShareCreateApiResponse,
        AppCoreLeadersShareCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/${queryArg.id}/share/`,
          method: "POST",
          body: queryArg.mutateSharedLeaderGrantRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersUploadProfilePicCreate: build.mutation<
        AppCoreLeadersUploadProfilePicCreateApiResponse,
        AppCoreLeadersUploadProfilePicCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/${queryArg.id}/upload_profile_pic/`,
          method: "POST",
          body: queryArg.leaderRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersAdminCreateCreate: build.mutation<
        AppCoreLeadersAdminCreateCreateApiResponse,
        AppCoreLeadersAdminCreateCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/admin-create/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreLeadersAdminLeaderProfileCategoriesRetrieve: build.query<
        AppCoreLeadersAdminLeaderProfileCategoriesRetrieveApiResponse,
        AppCoreLeadersAdminLeaderProfileCategoriesRetrieveApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-core/leaders/admin-leader-profile-categories/`,
        }),
        providesTags: ["api"],
      }),
      appCoreLeadersAdminListRetrieve: build.query<
        AppCoreLeadersAdminListRetrieveApiResponse,
        AppCoreLeadersAdminListRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-core/leaders/admin-list/` }),
        providesTags: ["api"],
      }),
      appCoreLeadersAdminSharedLeaderGrantsRetrieve: build.query<
        AppCoreLeadersAdminSharedLeaderGrantsRetrieveApiResponse,
        AppCoreLeadersAdminSharedLeaderGrantsRetrieveApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-core/leaders/admin-shared-leader-grants/`,
        }),
        providesTags: ["api"],
      }),
      appCoreLeadersBatchReorderCreate: build.mutation<
        AppCoreLeadersBatchReorderCreateApiResponse,
        AppCoreLeadersBatchReorderCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/leaders/batch-reorder/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreOauthLogoutCreate: build.mutation<
        AppCoreOauthLogoutCreateApiResponse,
        AppCoreOauthLogoutCreateApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-core/oauth/logout/`,
          method: "POST",
        }),
        invalidatesTags: ["api"],
      }),
      appCoreOauthMsLoginRetrieve: build.query<
        AppCoreOauthMsLoginRetrieveApiResponse,
        AppCoreOauthMsLoginRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-core/oauth/ms-login/` }),
        providesTags: ["api"],
      }),
      appCoreOauthSalesforceLoginRetrieve: build.query<
        AppCoreOauthSalesforceLoginRetrieveApiResponse,
        AppCoreOauthSalesforceLoginRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-core/oauth/salesforce-login/` }),
        providesTags: ["api"],
      }),
      appCoreOauthSaveGrantCreate: build.mutation<
        AppCoreOauthSaveGrantCreateApiResponse,
        AppCoreOauthSaveGrantCreateApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-core/oauth/save_grant/`,
          method: "POST",
        }),
        invalidatesTags: ["api"],
      }),
      appCoreOauthZoomLoginRetrieve: build.query<
        AppCoreOauthZoomLoginRetrieveApiResponse,
        AppCoreOauthZoomLoginRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-core/oauth/zoom-login/` }),
        providesTags: ["api"],
      }),
      appCoreOrgSharedLeadersList: build.query<
        AppCoreOrgSharedLeadersListApiResponse,
        AppCoreOrgSharedLeadersListApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-core/org_shared_leaders/` }),
        providesTags: ["OrgSharedLeaderGrant"],
      }),
      appCoreOrgSharedLeadersRetrieve: build.query<
        AppCoreOrgSharedLeadersRetrieveApiResponse,
        AppCoreOrgSharedLeadersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/org_shared_leaders/${queryArg}/`,
        }),
        providesTags: ["OrgSharedLeaderGrant"],
      }),
      appCoreOrgSharedLeadersUpdate: build.mutation<
        AppCoreOrgSharedLeadersUpdateApiResponse,
        AppCoreOrgSharedLeadersUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/org_shared_leaders/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.sharedLeaderGrantRequest,
        }),
        invalidatesTags: ["OrgSharedLeaderGrant"],
      }),
      appCoreOrgSharedLeadersPartialUpdate: build.mutation<
        AppCoreOrgSharedLeadersPartialUpdateApiResponse,
        AppCoreOrgSharedLeadersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/org_shared_leaders/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedSharedLeaderGrant,
        }),
        invalidatesTags: ["OrgSharedLeaderGrant"],
      }),
      appCoreOrgSharedLeadersRevokePartialUpdate: build.mutation<
        AppCoreOrgSharedLeadersRevokePartialUpdateApiResponse,
        AppCoreOrgSharedLeadersRevokePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/org_shared_leaders/${queryArg.id}/revoke/`,
          method: "PATCH",
          body: queryArg.patchedSharedLeaderGrant,
        }),
        invalidatesTags: ["OrgSharedLeaderGrant"],
      }),
      appCoreSharedLeadersList: build.query<
        AppCoreSharedLeadersListApiResponse,
        AppCoreSharedLeadersListApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-core/shared_leaders/` }),
        providesTags: ["api"],
      }),
      appCoreSharedLeadersCreate: build.mutation<
        AppCoreSharedLeadersCreateApiResponse,
        AppCoreSharedLeadersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/shared_leaders/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreSharedLeadersRetrieve: build.query<
        AppCoreSharedLeadersRetrieveApiResponse,
        AppCoreSharedLeadersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/shared_leaders/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      appCoreSharedLeadersUpdate: build.mutation<
        AppCoreSharedLeadersUpdateApiResponse,
        AppCoreSharedLeadersUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/shared_leaders/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.sharedLeaderGrantRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreSharedLeadersPartialUpdate: build.mutation<
        AppCoreSharedLeadersPartialUpdateApiResponse,
        AppCoreSharedLeadersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/shared_leaders/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedSharedLeaderGrant,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreSharedLeadersAdminRevokePartialUpdate: build.mutation<
        AppCoreSharedLeadersAdminRevokePartialUpdateApiResponse,
        AppCoreSharedLeadersAdminRevokePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/shared_leaders/${queryArg.id}/admin-revoke/`,
          method: "PATCH",
          body: queryArg.patchedSharedLeaderGrant,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreSharedLeadersRevokePartialUpdate: build.mutation<
        AppCoreSharedLeadersRevokePartialUpdateApiResponse,
        AppCoreSharedLeadersRevokePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-core/shared_leaders/${queryArg.id}/revoke/`,
          method: "PATCH",
          body: queryArg.patchedSharedLeaderGrant,
        }),
        invalidatesTags: ["api"],
      }),
      appCoreWebhooksZoomDeauthorizeCreate: build.mutation<
        AppCoreWebhooksZoomDeauthorizeCreateApiResponse,
        AppCoreWebhooksZoomDeauthorizeCreateApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-core/webhooks/zoom/deauthorize`,
          method: "POST",
        }),
        invalidatesTags: ["api"],
      }),
      appCoreWebhooksZoomUserSettingsCreate: build.mutation<
        AppCoreWebhooksZoomUserSettingsCreateApiResponse,
        AppCoreWebhooksZoomUserSettingsCreateApiArg
      >({
        query: () => ({
          url: `/api/v1_15/app-core/webhooks/zoom/user-settings`,
          method: "POST",
        }),
        invalidatesTags: ["api"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as appCoreApi };
export type AppCoreDevicesListApiResponse =
  /** status 200  */ PaginatedFcmDeviceList;
export type AppCoreDevicesListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppCoreDevicesCreateApiResponse = /** status 201  */ FcmDevice;
export type AppCoreDevicesCreateApiArg = FcmDeviceRequest;
export type AppCoreDevicesRetrieveApiResponse = /** status 200  */ FcmDevice;
export type AppCoreDevicesRetrieveApiArg = string;
export type AppCoreDevicesUpdateApiResponse = /** status 200  */ FcmDevice;
export type AppCoreDevicesUpdateApiArg = {
  registrationId: string;
  fcmDeviceRequest: FcmDeviceRequest;
};
export type AppCoreDevicesPartialUpdateApiResponse =
  /** status 200  */ FcmDevice;
export type AppCoreDevicesPartialUpdateApiArg = {
  registrationId: string;
  patchedFcmDevice: PatchedFcmDevice;
};
export type AppCoreDevicesDestroyApiResponse = unknown;
export type AppCoreDevicesDestroyApiArg = string;
export type AppCoreLeadersListApiResponse =
  /** status 200  */ PaginatedLeaderList;
export type AppCoreLeadersListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppCoreLeadersCreateApiResponse = /** status 201  */ Leader;
export type AppCoreLeadersCreateApiArg = LeaderRequest;
export type AppCoreLeadersRetrieveApiResponse = /** status 200  */ Leader;
export type AppCoreLeadersRetrieveApiArg =
  /** A unique integer value identifying this leader. */ number;
export type AppCoreLeadersUpdateApiResponse = /** status 200  */ Leader;
export type AppCoreLeadersUpdateApiArg = {
  /** A unique integer value identifying this leader. */
  id: number;
  leaderRequest: LeaderRequest;
};
export type AppCoreLeadersPartialUpdateApiResponse = /** status 200  */ Leader;
export type AppCoreLeadersPartialUpdateApiArg = {
  /** A unique integer value identifying this leader. */
  id: number;
  patchedLeader: PatchedLeader;
};
export type AppCoreLeadersDestroyApiResponse = unknown;
export type AppCoreLeadersDestroyApiArg =
  /** A unique integer value identifying this leader. */ number;
export type AppCoreLeadersAdminDeleteDestroyApiResponse = unknown;
export type AppCoreLeadersAdminDeleteDestroyApiArg =
  /** A unique integer value identifying this leader. */ number;
export type AppCoreLeadersAdminPatchPartialUpdateApiResponse =
  /** status 200  */ Leader;
export type AppCoreLeadersAdminPatchPartialUpdateApiArg = {
  /** A unique integer value identifying this leader. */
  id: number;
  patchedLeader: PatchedLeader;
};
export type AppCoreLeadersAdminShareLeaderCreateApiResponse =
  /** status 200  */ SharedLeaderGrant;
export type AppCoreLeadersAdminShareLeaderCreateApiArg = {
  /** A unique integer value identifying this leader. */
  id: number;
  mutateSharedLeaderGrantRequest: MutateSharedLeaderGrantRequest;
};
export type AppCoreLeadersAdminTransferLeaderCreateApiResponse =
  /** status 200  */ Leader;
export type AppCoreLeadersAdminTransferLeaderCreateApiArg = {
  /** A unique integer value identifying this leader. */
  id: number;
  leaderRequest: LeaderRequest;
};
export type AppCoreLeadersAdminUploadProfilePicCreateApiResponse =
  /** status 200  */ Leader;
export type AppCoreLeadersAdminUploadProfilePicCreateApiArg = {
  /** A unique integer value identifying this leader. */
  id: number;
  leaderRequest: LeaderRequest;
};
export type AppCoreLeadersShareCreateApiResponse =
  /** status 200  */ SharedLeaderGrant;
export type AppCoreLeadersShareCreateApiArg = {
  /** A unique integer value identifying this leader. */
  id: number;
  mutateSharedLeaderGrantRequest: MutateSharedLeaderGrantRequest;
};
export type AppCoreLeadersUploadProfilePicCreateApiResponse =
  /** status 200  */ Leader;
export type AppCoreLeadersUploadProfilePicCreateApiArg = {
  /** A unique integer value identifying this leader. */
  id: number;
  leaderRequest: LeaderRequest;
};
export type AppCoreLeadersAdminCreateCreateApiResponse =
  /** status 200  */ Leader;
export type AppCoreLeadersAdminCreateCreateApiArg = LeaderRequest;
export type AppCoreLeadersAdminLeaderProfileCategoriesRetrieveApiResponse =
  /** status 200  */ Leader;
export type AppCoreLeadersAdminLeaderProfileCategoriesRetrieveApiArg = void;
export type AppCoreLeadersAdminListRetrieveApiResponse =
  /** status 200  */ Leader;
export type AppCoreLeadersAdminListRetrieveApiArg = void;
export type AppCoreLeadersAdminSharedLeaderGrantsRetrieveApiResponse =
  /** status 200  */ Leader;
export type AppCoreLeadersAdminSharedLeaderGrantsRetrieveApiArg = void;
export type AppCoreLeadersBatchReorderCreateApiResponse =
  /** status 200  */ Leader;
export type AppCoreLeadersBatchReorderCreateApiArg = LeaderRequest;
export type AppCoreOauthLogoutCreateApiResponse = unknown;
export type AppCoreOauthLogoutCreateApiArg = void;
export type AppCoreOauthMsLoginRetrieveApiResponse = unknown;
export type AppCoreOauthMsLoginRetrieveApiArg = void;
export type AppCoreOauthSalesforceLoginRetrieveApiResponse = unknown;
export type AppCoreOauthSalesforceLoginRetrieveApiArg = void;
export type AppCoreOauthSaveGrantCreateApiResponse = unknown;
export type AppCoreOauthSaveGrantCreateApiArg = void;
export type AppCoreOauthZoomLoginRetrieveApiResponse = unknown;
export type AppCoreOauthZoomLoginRetrieveApiArg = void;
export type AppCoreOrgSharedLeadersListApiResponse =
  /** status 200  */ SharedLeaderGrant[];
export type AppCoreOrgSharedLeadersListApiArg = void;
export type AppCoreOrgSharedLeadersRetrieveApiResponse =
  /** status 200  */ SharedLeaderGrant;
export type AppCoreOrgSharedLeadersRetrieveApiArg =
  /** A unique integer value identifying this shared leader grant. */ number;
export type AppCoreOrgSharedLeadersUpdateApiResponse =
  /** status 200  */ SharedLeaderGrant;
export type AppCoreOrgSharedLeadersUpdateApiArg = {
  /** A unique integer value identifying this shared leader grant. */
  id: number;
  sharedLeaderGrantRequest: SharedLeaderGrantRequest;
};
export type AppCoreOrgSharedLeadersPartialUpdateApiResponse =
  /** status 200  */ SharedLeaderGrant;
export type AppCoreOrgSharedLeadersPartialUpdateApiArg = {
  /** A unique integer value identifying this shared leader grant. */
  id: number;
  patchedSharedLeaderGrant: PatchedSharedLeaderGrant;
};
export type AppCoreOrgSharedLeadersRevokePartialUpdateApiResponse =
  /** status 200  */ SharedLeaderGrant;
export type AppCoreOrgSharedLeadersRevokePartialUpdateApiArg = {
  /** A unique integer value identifying this shared leader grant. */
  id: number;
  patchedSharedLeaderGrant: PatchedSharedLeaderGrant;
};
export type AppCoreSharedLeadersListApiResponse =
  /** status 200  */ SharedLeaderGrant[];
export type AppCoreSharedLeadersListApiArg = void;
export type AppCoreSharedLeadersCreateApiResponse =
  /** status 201  */ SharedLeaderGrant;
export type AppCoreSharedLeadersCreateApiArg = SharedLeaderGrantRequest;
export type AppCoreSharedLeadersRetrieveApiResponse =
  /** status 200  */ SharedLeaderGrant;
export type AppCoreSharedLeadersRetrieveApiArg = string;
export type AppCoreSharedLeadersUpdateApiResponse =
  /** status 200  */ SharedLeaderGrant;
export type AppCoreSharedLeadersUpdateApiArg = {
  id: string;
  sharedLeaderGrantRequest: SharedLeaderGrantRequest;
};
export type AppCoreSharedLeadersPartialUpdateApiResponse =
  /** status 200  */ SharedLeaderGrant;
export type AppCoreSharedLeadersPartialUpdateApiArg = {
  id: string;
  patchedSharedLeaderGrant: PatchedSharedLeaderGrant;
};
export type AppCoreSharedLeadersAdminRevokePartialUpdateApiResponse =
  /** status 200  */ SharedLeaderGrant;
export type AppCoreSharedLeadersAdminRevokePartialUpdateApiArg = {
  id: string;
  patchedSharedLeaderGrant: PatchedSharedLeaderGrant;
};
export type AppCoreSharedLeadersRevokePartialUpdateApiResponse =
  /** status 200  */ SharedLeaderGrant;
export type AppCoreSharedLeadersRevokePartialUpdateApiArg = {
  id: string;
  patchedSharedLeaderGrant: PatchedSharedLeaderGrant;
};
export type AppCoreWebhooksZoomDeauthorizeCreateApiResponse = unknown;
export type AppCoreWebhooksZoomDeauthorizeCreateApiArg = void;
export type AppCoreWebhooksZoomUserSettingsCreateApiResponse = unknown;
export type AppCoreWebhooksZoomUserSettingsCreateApiArg = void;
export type FcmDevice = {
  id: number;
  name?: string | null;
  registration_id: string;
  /** Unique device identifier */
  device_id?: string | null;
  /** Inactive devices will not be sent notifications */
  active?: boolean;
  date_created: string | null;
  /** * `ios` - ios
   * `android` - android
   * `web` - web */
  type: "ios" | "android" | "web";
};
export type PaginatedFcmDeviceList = {
  data: FcmDevice[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type FcmDeviceRequest = {
  name?: string | null;
  registration_id: string;
  /** Unique device identifier */
  device_id?: string | null;
  /** Inactive devices will not be sent notifications */
  active?: boolean;
  /** * `ios` - ios
   * `android` - android
   * `web` - web */
  type: "ios" | "android" | "web";
};
export type PatchedFcmDevice = {
  name?: string | null;
  registration_id?: string;
  /** Unique device identifier */
  device_id?: string | null;
  /** Inactive devices will not be sent notifications */
  active?: boolean;
  /** * `ios` - ios
   * `android` - android
   * `web` - web */
  type?: "ios" | "android" | "web";
};
export type LeaderCalendar = {
  calendar: number;
  prevent_conflict?: boolean;
  allow_calendar_analytics?: boolean;
  allow_crm?: boolean;
};
export type Leader = {
  id: number;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  company?: string | null;
  primary_assistant?: number | null;
  industry?: number | null;
  industry_display: string;
  role?: string | null;
  pic_url?: string | null;
  country?: number | null;
  country_code: string;
  location_display: string;
  postal_code?: string | null;
  state?: string | null;
  state_short?: string | null;
  city?: string | null;
  phone_number?: string | null;
  custom?: any;
  color?: string;
  order: number;
  leader_calendars?: LeaderCalendar[];
  organization?: number | null;
};
export type PaginatedLeaderList = {
  data: Leader[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type LeaderCalendarRequest = {
  calendar: number;
  prevent_conflict?: boolean;
  allow_calendar_analytics?: boolean;
  allow_crm?: boolean;
};
export type LeaderRequest = {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  company?: string | null;
  primary_assistant?: number | null;
  industry?: number | null;
  role?: string | null;
  pic_url?: Blob | null;
  country?: number | null;
  postal_code?: string | null;
  state?: string | null;
  state_short?: string | null;
  city?: string | null;
  phone_number?: string | null;
  custom?: any;
  color?: string;
  leader_calendars?: LeaderCalendarRequest[];
  organization?: number | null;
};
export type PatchedLeader = {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  company?: string | null;
  primary_assistant?: number | null;
  industry?: number | null;
  role?: string | null;
  pic_url?: Blob | null;
  country?: number | null;
  postal_code?: string | null;
  state?: string | null;
  state_short?: string | null;
  city?: string | null;
  phone_number?: string | null;
  custom?: any;
  color?: string;
  leader_calendars?: LeaderCalendarRequest[];
  organization?: number | null;
};
export type PicUrl = {
  pic_url: string | null;
};
export type UserRealName = {
  id: number;
  first_name: string;
  last_name: string;
  profile: PicUrl;
  email: string;
};
export type SharedLeaderGrant = {
  id: number;
  leader: number;
  start_date: string | null;
  end_date: string | null;
  /** Convert ManyToMany permissions to structured data. */
  permissions: {
    [key: string]: any;
  };
  /** Convert ManyToMany category permissions to structured data. */
  category_permissions: {
    [key: string]: any;
  };
  /** Convert ManyToMany scheduling permissions to structured data. */
  scheduling_permissions: {
    [key: string]: any;
  };
  /** CRM contact permissions on this grant (view, add, change, delete). */
  crm_contact_permissions: {
    [key: string]: any;
  };
  to_user: UserRealName;
  is_admin: boolean;
};
export type MutateSharedLeaderGrantRequest = {
  collaboratorIds: number[];
  permissions: {
    [key: string]: {
      [key: string]: boolean;
    };
  };
  category_permissions: {
    [key: string]: {
      [key: string]: boolean;
    };
  };
  scheduling_permissions: {
    [key: string]: boolean;
  };
  crm_contact_permissions?: {
    [key: string]: boolean;
  };
  startDate?: string;
  endDate?: string | null;
  isAdmin?: boolean;
  fromUser?: number | null;
};
export type SharedLeaderGrantRequest = {
  leader: number;
  start_date: string | null;
  end_date?: string | null;
  is_admin?: boolean;
  permissions_data?: {
    [key: string]: any;
  };
  scheduling_permissions_data?: {
    [key: string]: any;
  };
  category_permissions_data?: {
    [key: string]: any;
  };
  crm_contact_permissions_data?: {
    [key: string]: boolean;
  };
};
export type PatchedSharedLeaderGrant = {
  leader?: number;
  start_date?: string | null;
  end_date?: string | null;
  is_admin?: boolean;
  permissions_data?: {
    [key: string]: any;
  };
  scheduling_permissions_data?: {
    [key: string]: any;
  };
  category_permissions_data?: {
    [key: string]: any;
  };
  crm_contact_permissions_data?: {
    [key: string]: boolean;
  };
};
export const {
  useAppCoreDevicesListQuery,
  useAppCoreDevicesCreateMutation,
  useAppCoreDevicesRetrieveQuery,
  useAppCoreDevicesUpdateMutation,
  useAppCoreDevicesPartialUpdateMutation,
  useAppCoreDevicesDestroyMutation,
  useAppCoreLeadersListQuery,
  useAppCoreLeadersCreateMutation,
  useAppCoreLeadersRetrieveQuery,
  useAppCoreLeadersUpdateMutation,
  useAppCoreLeadersPartialUpdateMutation,
  useAppCoreLeadersDestroyMutation,
  useAppCoreLeadersAdminDeleteDestroyMutation,
  useAppCoreLeadersAdminPatchPartialUpdateMutation,
  useAppCoreLeadersAdminShareLeaderCreateMutation,
  useAppCoreLeadersAdminTransferLeaderCreateMutation,
  useAppCoreLeadersAdminUploadProfilePicCreateMutation,
  useAppCoreLeadersShareCreateMutation,
  useAppCoreLeadersUploadProfilePicCreateMutation,
  useAppCoreLeadersAdminCreateCreateMutation,
  useAppCoreLeadersAdminLeaderProfileCategoriesRetrieveQuery,
  useAppCoreLeadersAdminListRetrieveQuery,
  useAppCoreLeadersAdminSharedLeaderGrantsRetrieveQuery,
  useAppCoreLeadersBatchReorderCreateMutation,
  useAppCoreOauthLogoutCreateMutation,
  useAppCoreOauthMsLoginRetrieveQuery,
  useAppCoreOauthSalesforceLoginRetrieveQuery,
  useAppCoreOauthSaveGrantCreateMutation,
  useAppCoreOauthZoomLoginRetrieveQuery,
  useAppCoreOrgSharedLeadersListQuery,
  useAppCoreOrgSharedLeadersRetrieveQuery,
  useAppCoreOrgSharedLeadersUpdateMutation,
  useAppCoreOrgSharedLeadersPartialUpdateMutation,
  useAppCoreOrgSharedLeadersRevokePartialUpdateMutation,
  useAppCoreSharedLeadersListQuery,
  useAppCoreSharedLeadersCreateMutation,
  useAppCoreSharedLeadersRetrieveQuery,
  useAppCoreSharedLeadersUpdateMutation,
  useAppCoreSharedLeadersPartialUpdateMutation,
  useAppCoreSharedLeadersAdminRevokePartialUpdateMutation,
  useAppCoreSharedLeadersRevokePartialUpdateMutation,
  useAppCoreWebhooksZoomDeauthorizeCreateMutation,
  useAppCoreWebhooksZoomUserSettingsCreateMutation,
} = injectedRtkApi;
